<template>
    <div v-if="anexo" class="modal-overlay">
        <div class="modal-content proc-modal-upload">
            <h3 class="row-space">Novo anexo</h3>
            <p class="proc-modal-subtitle">{{ anexo.nmtpdoc }}</p>

            <div v-if="msgAlerta" class="info-alert proc-alert" @click="$emit('limpar-alerta')">
                <span class="text">{{ msgAlerta }}</span>
            </div>

            <div class="row row-space">
                <div class="form-item">
                    <AnexoUploadField ref="uploaderRef" :maxSizeMB="20" />
                </div>
            </div>

            <div class="row row-space proc-upload-row">
                <div class="form-item">
                    <label class="label-caption">Nome/Identificação</label>
                    <input type="text" :value="nome" maxlength="100" v-uppercase @input="$emit('update:nome', $event.target.value)" />
                </div>

                <div v-show="anexo.ckvalidade === 'S'" class="form-item-char15">
                    <label class="label-caption">Válido até</label>
                    <input type="date" :value="validade" @input="$emit('update:validade', $event.target.value)" />
                </div>
            </div>

            <div class="row row-space">
                <div class="form-item">
                    <label class="label-caption">Informações</label>
                    <textarea :value="info" maxlength="1000" rows="3" @input="$emit('update:info', $event.target.value)" />
                </div>
            </div>

            <div class="row-end">
                <button class="btn-small proc-btn primary" type="button" @click="$emit('salvar')">Enviar</button>
                <button class="btn-small proc-btn" type="button" @click="$emit('fechar')">Fechar</button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import AnexoUploadField from '@/fields/AnexoUploadField.vue';

defineProps({
    anexo: { type: Object, default: null },
    nome: { type: String, default: '' },
    validade: { type: String, default: '' },
    info: { type: String, default: '' },
    msgAlerta: { type: String, default: null },
});

defineEmits([
    'update:nome',
    'update:validade',
    'update:info',
    'salvar',
    'fechar',
    'limpar-alerta',
]);

const uploaderRef = ref(null);

function getUploader() {
    if (Array.isArray(uploaderRef.value)) return uploaderRef.value[0];
    return uploaderRef.value;
}

defineExpose({ getUploader });
</script>
